var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_2278)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_255_2278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 65C53.75 65 65 53.75 65 40C65 26.25 53.75 15 40 15C26.25 15 15 26.25 15 40C15 53.75 26.25 65 40 65Z",
    fill: "#3C4AF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5765 32.2473C38.8707 32.2473 38.3015 32.031 37.8689 31.5984C37.4362 31.143 37.2199 30.5624 37.2199 29.8566C37.2199 29.1507 37.4362 28.5815 37.8689 28.1489C38.3015 27.7163 38.8707 27.5 39.5765 27.5C40.2596 27.5 40.8288 27.7163 41.2842 28.1489C41.7395 28.5815 41.9672 29.1507 41.9672 29.8566C41.9672 30.5624 41.7395 31.143 41.2842 31.5984C40.8288 32.031 40.2596 32.2473 39.5765 32.2473ZM35.4443 36.1973C35.1903 36.1649 35 35.9489 35 35.6929C35 35.4121 35.2276 35.1844 35.5084 35.1844H38.2787C40.0895 35.1844 41.5574 36.6524 41.5574 38.4631V49.6312C41.5574 50.4053 41.5915 50.872 41.6598 51.0314C41.7281 51.168 41.9444 51.2591 42.3087 51.3047L43.7429 51.4872C43.9968 51.5195 44.1872 51.7356 44.1872 51.9916C44.1872 52.2724 43.9595 52.5 43.6787 52.5H35.5084C35.2276 52.5 35 52.2724 35 51.9916C35 51.7356 35.1903 51.5195 35.4443 51.4872L36.8784 51.3047C37.2427 51.2591 37.459 51.168 37.5273 51.0314C37.5956 50.872 37.6298 50.4053 37.6298 49.6312V38.0533C37.6298 37.2792 37.5956 36.8238 37.5273 36.6872C37.459 36.5278 37.2427 36.4253 36.8784 36.3798L35.4443 36.1973Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_255_2278",
    x: -5,
    y: -2.00001,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.290196 0 0 0 0 0.945098 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_2278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_255_2278",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_2278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleActive);
export default __webpack_public_path__ + "static/media/info-circle-active.8d2f6e1331063ab0f0f9c86f5cc50e90.svg";
export { ForwardRef as ReactComponent };